import { Box, Flex } from '@pancakeswap/uikit'
import { styled } from 'styled-components'

export const AdvancedDetailsFooter = styled(Box)<{ show: boolean }>`
  // margin-top: ${({ show }) => (show ? '16px' : 0)};
  // padding-top: 16px;
  // padding-bottom: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  padding: 16px 12px;
  // flex-wrap: wrap;
  // border-radius: var(--radii-default);
  // border: 1px solid var(--colors-cardBorder);
  // background-color: var(--colors-background);

  transform: ${({ show }) => (show ? 'translateY(0%)' : 'translateY(-100%)')};
  transition: transform 300ms ease-in-out;

  & > div {
    flex-direction: column;
    align-items: flex-start;
    flex: 0 0 30%;
  }
  gap: 16px;

  ${({ theme }) => theme.mediaQueries._sm} {
    display: flex;
    flex-direction: column;
    & > div {
      flex-direction: row;
    }
  }
`
